import React from 'react';
import { Container, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MainNav from '../Modules/nav/components/MainNav';
import FooterNav from '../Modules/nav/components/FooterNav';

const useStyles = makeStyles((theme) => ({
    '@global': {
        'html, body': {
            height: '100%',
        },
    },

    main: {
        minHeight: '88%',
    },

    version: {
        position: 'absolute',
        right: theme.spacing(1),
    },
}));

const WelcomePage = () => {
    const classes = useStyles();

    return (
        <>
            <MainNav />
            <Container className={classes.main}>
                <Typography variant="h1">Kein Token</Typography>
                <Typography variant="body2">Bitte wenden Sie sich an Pflege zu Hause.</Typography>
            </Container>
            <FooterNav />
        </>
    );
};

WelcomePage.propTypes = {};

WelcomePage.defaultProps = {};

export default WelcomePage;
